// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"3":"component---src-pages-news-js","351":"commons","441":"d676735c","532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"3":"fa480518d9b03a722a1b","351":"d02d79f51ac15fcd0170","441":"94fc76c9cdb371af8e6a","532":"0f4f7e8113a353323b5c","678":"612deafb859536be5a8e"}[chunkId] + ".js";
};